document.querySelectorAll('.dk-workshops form').forEach((form) => {
  const type = form.querySelector('[name="contact[Workshop type]"]');
  const count = form.querySelector('[name="contact[Number of skaters]"]');
  if (!type || !count) return;
  const update = () => {
    const isPrivate = type.value === 'Private — 1 skater';
    const isGroup = type.value === 'Small group — 2–4 skaters';
    Array.from(count.options).forEach(option => {
      if (!option.value) return;
      option.disabled = isPrivate ? option.value !== '1' : isGroup ? option.value === '1' : false;
    });
    if (isPrivate) count.value = '1';
    if (isGroup && count.value === '1') count.value = '';
  };
  type.addEventListener('change', update);
  update();
});
